import { render, staticRenderFns } from "./CustomCarouselItem.vue?vue&type=template&id=4c5249a0"
import script from "./CustomCarouselItem.vue?vue&type=script&lang=js"
export * from "./CustomCarouselItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports